import { getFlagEmoji } from '@advanza/func'
import { SelectCheckbox, SelectSimple } from '@advanza/input'
import ServicesSelectContainer from 'containers/ServicesSelectContainer'
import { useAppSelector } from 'hooks/hooks'
import React, { useEffect } from 'react'

const ServicesSelect = ({
    serviceIds = [],
    multiple = true,
    countryCode,
    services,
    filter,
    returnObject,
    value,
    useSelectedCountry = true,
    fetchServices,
    placeholder = 'all services',
    ...rest
}) => {
    let ids = filter ? serviceIds.filter(filter) : serviceIds
    const selectedCountries = useAppSelector((state) => state.countries.countries) || []
    if (countryCode) {
        ids = serviceIds.filter(
            (id) =>
                services[parseInt(id, 10)] &&
                services[parseInt(id, 10)].country_code === countryCode,
        )
    } else if (useSelectedCountry) {
        ids = serviceIds.filter(
            (id) =>
                services[parseInt(id, 10)] &&
                selectedCountries.includes(services[parseInt(id, 10)].country_code),
        )
    }
    useEffect(() => {
        fetchServices()
    }, [fetchServices])
    const items = ids
        .map((id) => {
            const service = services[parseInt(id, 10)]
            if (!service) return null
            return {
                name: service.name + ' ' + getFlagEmoji(service.country_code),
                value: service.service_id,
                countryCode: service.country_code,
                sn: service.name,
            }
        })
        .filter(Boolean)
        .sort((a, b) =>
            a.countryCode < b.countryCode
                ? 1
                : a.countryCode > b.countryCode
                  ? -1
                  : a.sn.localeCompare(b.sn),
        )
    if (multiple) {
        return <SelectCheckbox placeholder={placeholder} {...rest} options={items} value={value} />
    }

    return (
        <SelectSimple
            placeholder={placeholder}
            {...rest}
            onChange={(e) =>
                rest.onChangeValue(
                    e.target.value
                        ? [returnObject ? services[parseInt(e.target.value, 10)] : e.target.value]
                        : [],
                )
            }
            options={items}
            alwaysControlValue
            value={Array.isArray(value) ? value[0] || null : value}
        />
    )
}

export default ServicesSelectContainer(ServicesSelect)
